<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="margin-top:150px;">I’d like to thank Austin Macauley Publishers and Ms. Rebecca Slack for taking the chance on a first-time author. I’d like to thank all the editors that had to edit my run-on sentences and fix my terrible spelling.</p><br/>
<p>I want to thank all the authors that came before and inspired my love of reading.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?053ebebe